/** A request to open is not proof of a visible gift. Acknowledge after paint,
 * in a visible tab, with the card on screen and unobscured by another dialog.
 * DOM/visibility events recheck covered cards without a polling loop.
 */
export function observeWelcomeVisibility(element: HTMLElement, onVisible: () => void): () => void {
  let frame = 0;
  let stopped = false;
  const stop = () => {
    stopped = true;
    cancelAnimationFrame(frame);
    observer.disconnect();
    document.removeEventListener('visibilitychange', schedule);
    element.removeEventListener('animationend', schedule);
  };
  const schedule = () => {
    if (stopped || frame || document.visibilityState !== 'visible') return;
    frame = requestAnimationFrame(() => {
      frame = requestAnimationFrame(() => {
        frame = 0;
        if (stopped || !element.isConnected || document.visibilityState !== 'visible') return;
        const rect = element.getBoundingClientRect();
        const style = getComputedStyle(element);
        if (!rect.width || !rect.height || style.visibility === 'hidden' || Number(style.opacity) === 0) return;
        const x = Math.max(0, Math.min(innerWidth - 1, rect.left + rect.width / 2));
        const y = Math.max(0, Math.min(innerHeight - 1, rect.top + rect.height / 2));
        if (!element.contains(document.elementFromPoint(x, y))) return;
        stop();
        onVisible();
      });
    });
  };
  const observer = new MutationObserver(schedule);
  observer.observe(document.body, {subtree: true, childList: true,
    attributes: true, attributeFilter: ['class', 'style', 'hidden', 'open']});
  document.addEventListener('visibilitychange', schedule);
  element.addEventListener('animationend', schedule);
  schedule();
  return stop;
}
